<vnm-persistent-notification
  icon="user-secret"
  [message]="'impersonation-notification.message' | translate: { userFullName: userFullName$ | async }"
  (click)="presentClearImpersonation()"
></vnm-persistent-notification>
